import { render, staticRenderFns } from "./Slide1.vue?vue&type=template&id=39b8aa9a&scoped=true&lang=pug"
import script from "./Slide1.vue?vue&type=script&lang=js"
export * from "./Slide1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b8aa9a",
  null
  
)

export default component.exports